import Service from '../../services'
import Swal from "sweetalert2";
// initial state
const state = {

    // Title
    allTopic: [],
    allTopicPaginate: {},
    topicForm: {
        name_th: '',
        name_en: ''
    },

    // Number box
    numberBox: [],

    // Imported
    allImported: [],
    allImportedPaginate: {},
    importedForm: {
        topic_id: '',
        index_id: null,
        year_data: null,
        file_path: '',
        display_status: 0,
        name: ''
    },


    // Unit
    unitForm: {
        name_th: '',
        name_en: ''
    },

    allUnitPaginate: {},
    allUnit: [],


    // Tag
    allTag: [],
    allTagPaginate: {
        data: []
    },

    tagForm: {
        name: ''
    },

    //main menu
    mainMenuPaginate: {
        data: []
    },
    mainMenuForm: {
        id: null,
        name_th: '',
        name_en: '',
        src_url: '',
        status: 0,
    }

};


// getters
const getters = {
    tagOption: (state) => {
        let tag = [];
        for (let i = 0; i < state.allTag.length; i++) {
            tag.push({
                id: state.allTag[i].id,
                text: state.allTag[i].name
            });
        }
        return tag;
    },
    unitOption: (state) => {
        let unit = [];
        for (let i = 0; i < state.allUnit.length; i++) {
            unit.push({
                unit_id: state.allUnit[i].unit_id,
                text_th: state.allUnit[i].name_th
            })
        }
        return unit;
    },

    topicOption: (state) => {
        let topic = [];
        for (let i = 0; i < state.allTopic.length; i++) {
            topic.push({
                id: state.allTopic[i].id,
                text: state.allTopic[i].name_th
            })
        }
        return topic;
    },

    nameOption: (state) => {
        let name = [];
        for (let i = 0; i < state.allImported.length; i++) {
            name.push({
                id: state.allImported[i].id,
                text: state.allImported[i].name
            })
        }
        return name;
    }

};


// actions
const actions = {
    // Title
    onGetAllTopic({ commit }, data) {
        return Service.data.getAllTopic(data).then((res) => {
            commit('setAllTopic', res);
        });
    },

    onGetAllTopicPaginate({ commit }, data) {
        return Service.data.getAllTopicPaginate(data).then((res) => {
            commit('setAllTopicPaginate', res);
        });
    },

    onGetTopic({ commit }, data) {
        return Service.data.getTopic(data).then((res) => {
            commit('setTopic', res);
        });
    },

    onCreateTopic({ commit }, data) {
        return Service.data.createTopic(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'เพิ่มข้อมูลสำเร็จ',
            })
            // alert('เพิ่มข้อมูลสำเร็จ');
        })
    },

    onEditTopic({ commit }, data) {
        return Service.data.editTopic(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'แก้ไขข้อมูลสำเร็จ',
            })
            // alert('แก้ไขข้อมูลสำเร็จ');
        })
    },

    onDeleteTopic({ commit }, data) {
        return Service.data.deleteTopic(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'ลบข้อมูลสำเร็จ',
            })
            // alert('ลบข้อมูลสำเร็จ');
        })
    },


    // Imported
    onGetAllImported({ commit }, data) {
        return Service.data.getAllImported(data).then((res) => {
            commit('setAllImported', res);
        })
    },

    onGetAllImportedPaginate({ commit }, data) {
        return Service.data.getAllImportedPaginate(data).then((res) => {
            commit('setAllImportedPaginate', res);
        })
    },

    onGetImported({ commit }, data) {
        return Service.data.getImported(data).then((res) => {
            commit('setImported', res);
        })
    },

    onCreateImported({ commit }, data) {
        return Service.data.createImported(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'เพิ่มข้อมูลสำเร็จ',
            })
            // alert('เพิ่มข้อมูลสำเร็จ');
        })
    },

    onEditImported({ commit }, data) {
        return Service.data.editImported(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'แก้ไขข้อมูลสำเร็จ',
            })
            // alert('แก้ไขข้อมูลสำเร็จ');
        })
    },

    onDeleteImported({ commit }, data) {
        return Service.data.deleteImported(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'ลบข้อมูลสำเร็จ',
            })
            // alert('ลบข้อมูลสำเร็จ');
        })
    },


    // unit
    onGetAllUnit({ commit }, data) {
        return Service.data.getAllUnit(data).then((res) => {
            commit('setAllUnit', res);
        });
    },

    onGetAllUnitPaginate({ commit }, data) {
        return Service.data.getAllUnitPaginate(data).then((res) => {
            commit('setAllUnitPaginate', res);
        });
    },

    onGetUnit({ commit }, data) {
        return Service.data.getUnit(data).then((res) => {
            commit('setUnit', res);
        });
    },

    onCreateUnit({ commit }, data) {
        return Service.data.createUnit(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'เพิ่มข้อมูลสำเร็จ',
            })
            // alert('เพิ่มข้อมูลสำเร็จ');
        });
    },

    onEditUnit({ commit }, data) {
        return Service.data.editUnit(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'แก้ไขข้อมูลสำเร็จ',
            })
            // alert('แก้ไขข้อมูลสำเร็จ');
        });
    },

    onDeleteUnit({ commit }, data) {
        return Service.data.deleteUnit(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'ลบข้อมูลสำเร็จ',
            })
            // alert('ลบข้อมูลสำเร็จ');
        });
    },


    // tag
    onGetAllTag({ commit }, data) {
        return Service.data.getAllTag(data).then((res) => {
            commit('setAllTag', res);
        });
    },

    onGetAllTagPaginate({ commit }, data) {
        return Service.data.getAllTagPaginate(data).then((res) => {
            commit('setAllTagPaginate', res);
        });
    },

    onGetTag({ commit }, data) {
        return Service.data.getTag(data).then((res) => {
            commit('setTag', res);
        });
    },

    onCreateTag({ commit }, data) {
        return Service.data.createTag(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'เพิ่มข้อมูลสำเร็จ',
            })
            // alert('เพิ่มข้อมูลสำเร็จ');
        });
    },

    onEditTag({ commit }, data) {
        return Service.data.editTag(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'แก้ไขข้อมูลสำเร็จ',
            })
            // alert('แก้ไขข้อมูลสำเร็จ');
        });
    },

    onDeleteTag({ commit }, data) {
        return Service.data.deleteTag(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'ลบข้อมูลสำเร็จ',
            })
            // alert('ลบข้อมูลสำเร็จ');
        });
    },


    //main menu
    onGetAllMainMenu({ commit }, data) {
        return Service.data.index(data).then((res) => {
            commit('setAllMainMenu', res);
        });
    },

    onGetMainMenu({ commit }, data) {
        return Service.data.show(data).then((res) => {
            commit('setMainMenu', res);
        });
    },

    onEditMainMenu({ commit }, data) {
        return Service.data.update(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'แก้ไขข้อมูลสำเร็จ',
            })
            // alert('แก้ไขข้อมูลสำเร็จ');
        });
    },

    populateNumberBox({ commit }) {
        return Service.data.getNumberBox()
            .then(data => commit('setNumberBox', data))
    },

    populateNumberBoxDataStats({ commit }) {
        return Service.data.getNumberBoxDataStats()
            .then(data => commit('setNumberBoxDataStats', data))
    },

    updateNumberBox({ commit }, { id, topic_id }) {
        return Service.data.updateNumberBox(id, {
            topic_id: topic_id
        })
            .then(data => commit('setNumberBox', data))
    },

    updateNumberBoxDataStats({ commit }, { id, topic_id }) {
        return Service.data.updateNumberBoxDataStats(id, {
            topic_id: topic_id
        })
            .then(data => commit('setNumberBoxDataStats', data))
    }
};

// mutations
const mutations = {
    setNumberBox(state, data) {
        state.numberBox = data
    },
    setNumberBoxDataStats(state, data) {
        state.numberBoxDataStats = data
    },

    // Title
    setAllTopic(state, data) {
        state.allTopic = data;
    },

    setAllTopicPaginate(state, data) {
        state.allTopicPaginate = data;
    },

    setTopic(state, data) {
        state.topicForm = {
            name_th: data.name_th,
            name_en: data.name_en
        }
    },


    // Imported
    setAllImported(state, data) {
        state.allImported = data;
    },

    setAllImportedPaginate(state, data) {
        state.allImportedPaginate = data;
    },

    setImported(state, data) {
        state.importedForm = {
            topic_id: data.topic_id,
            index_id: data.index_id,
            year_data: data.year_data,
            file_path: data.file_path,
            display_status: data.display_status,
            name: ''
        }
    },


    // unit
    setAllUnit(state, data) {
        state.allUnit = data;
    },

    setAllUnitPaginate(state, data) {
        state.allUnitPaginate = data;
    },

    setUnit(state, data) {
        state.unitForm = {
            name_th: data.name_th,
            name_en: data.name_en
        };
    },


    // tag
    setAllTag(state, data) {
        state.allTag = data;
    },

    setAllTagPaginate(state, data) {
        state.allTagPaginate = data;
    },

    setTag(state, data) {
        state.tagForm = {
            name: data.name
        };
    },

    //main menu
    setAllMainMenu(state, data) {
        state.mainMenuPaginate = data;
    },

    setMainMenu(state, data) {
        state.mainMenuForm = {
            id: data.id,
            name_th: data.name_th,
            name_en: data.name_en,
            src_url: data.src_url,
            status: data.status,
        };
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
